export const API_ROOT = `${process.env.REACT_APP_API_PROTOCOL}${process.env.REACT_APP_API_DOMAIN}`  
export const WS_ROOT = `${process.env.REACT_APP_WS_PROTOCOL}${process.env.REACT_APP_API_DOMAIN}`
  